// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "a[data-v-53bb3305]{color:inherit}a[data-v-53bb3305],a[data-v-53bb3305]:focus,a[data-v-53bb3305]:hover{-webkit-text-decoration:none;text-decoration:none}small[data-v-53bb3305]{color:#767676}.profile-wrapper[data-v-53bb3305]{margin-right:.75rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
